import React, { CSSProperties, PropsWithChildren } from 'react';

import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const SectionBlock = ({
  title,
  children,
  className = '',
  wrapperStyle = {},
  titleStyle = {},
}: PropsWithChildren<{
  title: string;
  className?: string;
  wrapperStyle?: CSSProperties;
  titleStyle?: CSSProperties;
}>) => {
  return (
    <div style={wrapperStyle} className={cx(className, 'section-wrapper')}>
      <h1 style={titleStyle} className={cx('title')}>
        {title}
      </h1>
      {children}
    </div>
  );
};
